export default function toClipboard(text) {
  if (typeof navigator === 'undefined') return;
  const clipboard = navigator.clipboard
  if (clipboard) {
    return clipboard.writeText(text)
  } else {
    return Promise.reject('Clipboard api not available')
  }
}
